<template>
  <div class="container-full-5">
    <h1 class="secondary-font gap-4 mt-2 mb-2">
      Modifier mon PIN
    </h1>
    <p class="mb-5 text-grey-600">
      Changez votre code PIN pour sécuriser votre compte.
    </p>

    <div class="pin-card">
      <form @submit.prevent="handleChangePin">
        <div class="form-group">
          <label for="current-pin">PIN actuel</label>
          <input
            id="current-pin"
            v-model="currentPin"
            type="password"
            maxlength="4"
            class="form-input"
            placeholder="••••"
            required
          />
        </div>

        <div class="form-group">
          <label for="new-pin">Nouveau PIN</label>
          <input
            id="new-pin"
            v-model="newPin"
            type="password"
            maxlength="4"
            class="form-input"
            placeholder="••••"
            required
          />
        </div>

        <div class="form-group">
          <label for="confirm-pin">Confirmer le nouveau PIN</label>
          <input
            id="confirm-pin"
            v-model="confirmPin"
            type="password"
            maxlength="4"
            class="form-input"
            placeholder="••••"
            required
          />
        </div>

        <div v-if="error" class="alert alert-error">
          {{ error }}
        </div>

        <div v-if="success" class="alert alert-success">
          {{ success }}
        </div>

        <button type="submit" class="btn flex-center gap-2 mt-4">
          <img src="/public/icons/icon-menu-securite.svg" alt="" class="btn-icon btn-icon-white" />
          Modifier mon PIN
        </button>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'ChangerPin',
  setup() {
    const currentPin = ref('')
    const newPin = ref('')
    const confirmPin = ref('')
    const error = ref('')
    const success = ref('')

    const handleChangePin = () => {
      error.value = ''
      success.value = ''

      if (newPin.value !== confirmPin.value) {
        error.value = 'Les nouveaux PINs ne correspondent pas'
        return
      }

      if (newPin.value.length !== 4) {
        error.value = 'Le PIN doit contenir exactement 4 chiffres'
        return
      }

      // TODO: Appeler l'API pour changer le PIN
      success.value = 'Votre PIN a été modifié avec succès !'
      currentPin.value = ''
      newPin.value = ''
      confirmPin.value = ''
    }

    return {
      currentPin,
      newPin,
      confirmPin,
      error,
      success,
      handleChangePin
    }
  }
})
</script>

<style scoped>
.pin-card {
  max-width: 500px;
  margin-top: 2rem;
  padding: 2.5rem;
  border-radius: 24px;
  background: white;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(88, 101, 242, 0.08);
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  font-size: 0.9rem;
  font-weight: 600;
  color: rgb(34, 34, 34);
  margin-bottom: 0.5rem;
}

.form-input {
  width: 100%;
  padding: 0.9rem 1.2rem;
  border: 2px solid rgba(88, 101, 242, 0.15);
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.2s ease;
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 0.5rem;
}

.form-input:focus {
  outline: none;
  border-color: rgb(88, 101, 242);
  box-shadow: 0 0 0 4px rgba(88, 101, 242, 0.1);
}

.alert {
  padding: 1rem;
  border-radius: 12px;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.alert-error {
  background: rgba(220, 53, 69, 0.1);
  color: rgb(220, 53, 69);
  border: 1px solid rgba(220, 53, 69, 0.3);
}

.alert-success {
  background: rgba(0, 208, 180, 0.1);
  color: rgb(0, 150, 130);
  border: 1px solid rgba(0, 208, 180, 0.3);
}

.btn-icon-white {
  filter: brightness(0) invert(1);
}
</style>
